import React, { useEffect, useState } from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ onFinish }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      // Call onFinish callback after fade out animation
      setTimeout(() => {
        if (onFinish) onFinish();
      }, 500); // Wait for fade out animation
    }, 2500); // Show for 2.5 seconds

    return () => clearTimeout(timer);
  }, [onFinish]);

  if (!isVisible) return null;

  return (
    <div className={`loading-screen ${!isVisible ? 'fade-out' : ''}`}>
      <div className="loading-content">
        <div className="logo-container">
          <img src="/logo.jpg" alt="Алтай Логотип" className="loading-logo" />
        </div>
        <div className="app-title-loading">
          <h1>Тұрғын</h1>
          <h1>Житель</h1>
        </div>
        <div className="loading-description">
          <p className="description-both">Алтай қаласының оқиғаларды басқару жүйесі</p>
          <p className="description-both">Система управления событиями города Алтай</p>
        </div>
        <div className="loading-spinner">
          <div className="spinner"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;